(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        // Редактирование проверки звонка не покидая списка звонков
        .state('phone-call.editPhoneCallCheck', {
            parent: 'phone-call',
            url: '/phone-call-check/edit/{id}/{phoneCallId}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_CHECKER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'PhoneCallCheckTrackerService', '$translate', '$filter', function($stateParams, $state, $uibModal, PhoneCallCheckTrackerService, $translate, $filter) {
                var dto = PhoneCallCheckTrackerService.checkPhoneCallId($stateParams.phoneCallId);
                if (dto != null && dto['action'] == 'edit') {
                    var time = $filter('date')(dto['time'], 'dd.MM.yy HH:mm')
                    if (!confirm($translate.instant('global.editInParallel', {'param': time, 'user': dto['userLogin']}))) {
                        $state.go('phone-call', null, null);
                        return;
                    }
                }
                PhoneCallCheckTrackerService.sendEditPhoneCallId($stateParams.phoneCallId);
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-check/phone-call-check-dialog.html',
                    controller: 'PhoneCallCheckDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCallCheck', function(PhoneCallCheck) {
                            return PhoneCallCheck.get({id : $stateParams.id}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('phoneCallCheck');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call', null, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            onExit: ['$stateParams', 'PhoneCallCheckTrackerService', function($stateParams, PhoneCallCheckTrackerService){
                PhoneCallCheckTrackerService.sendCloseEditPhoneCallId($stateParams.phoneCallId);
                PhoneCallCheckTrackerService.cleanEditListener();
            }]
        })
        // Создание проверки звонка не покидая списка звонков
        .state('phone-call.newPhoneCallCheck', {
            parent: 'phone-call',
            url: '/phone-call-check/new/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_CHECKER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'PhoneCall', 'Principal', 'PhoneCallCheckTrackerService', '$translate', '$filter', function($stateParams, $state, $uibModal, PhoneCall, Principal, PhoneCallCheckTrackerService, $translate, $filter) {
                var dto = PhoneCallCheckTrackerService.checkPhoneCallId($stateParams.id);
                if (dto != null && dto['action'] == 'edit') {
                    var time = $filter('date')(dto['time'], 'dd.MM.yy HH:mm')
                    if (!confirm($translate.instant('global.editInParallel', {'param': time, 'user': dto['userLogin']}))) {
                        $state.go('phone-call', null, null);
                        return;
                    }
                }
                PhoneCallCheckTrackerService.sendEditPhoneCallId($stateParams.id);
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call-check/phone-call-check-dialog.html',
                    controller: 'PhoneCallCheckDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                assessment: null,
                                id: null,
                                phoneCall: PhoneCall.get({id : $stateParams.id}),
                                checkTime: new Date(),
                                systemic: false,
                                dummy: false
                            };
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('phoneCallCheck');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call', null, { reload: false });
                }, function() {
                    $state.go('phone-call');
                });
            }],
            onExit: ['$stateParams', 'PhoneCallCheckTrackerService', function($stateParams, PhoneCallCheckTrackerService){
                PhoneCallCheckTrackerService.sendCloseEditPhoneCallId($stateParams.id);
                PhoneCallCheckTrackerService.cleanEditListener();
            }]
        })
        // Просмотр проверки звонка не покидая списка звонков
        .state('phone-call.viewPhoneCallCheck', {
            parent: 'phone-call',
            url: '/phone-call-check-detail/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_CHECKER', 'ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-call/phone-call-check-ext-detail.html',
                    controller: 'PhoneCallCheckDetailExtController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneCallCheck', function(PhoneCallCheck) {
                            return PhoneCallCheck.get({id : $stateParams.id}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('phoneCallCheck');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }],
                        previousState: ["$state", function ($state) {
                            var currentStateData = {
                                name: $state.current.name || 'phone-call',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                            return currentStateData;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-call', null, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
